import { axiosErp } from '@/services/axios/index'
import { Data } from '@icon-park/vue'
import { method } from 'lodash'

export default {
  login(data, options = {}) {
    return axiosErp(
      {
        method: 'post',
        url: '/home/user/login',
        data,
        ...options,
      }
    )
  },
  getUserInfo() {
    return axiosErp(
      {
        method: 'get',
        url: '/home/user/getUserInfo',
      }
    )
  },
  acquireSysMenuByRights(params = {}, options = {}) {
    return axiosErp(
      {
        method: 'get',
        url: '/Home/Menu/acquireSysMenuByRights',
        params,
        ...options,
      }
    )
  },

}
